import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {
  InterestedCategory,
  InterestedCategoryCreateRequest,
  InterestedCategoryCreateResponse,
  InterestedCategoryDetails,
  InterestedCategoryUpdateRequest,
  InterestedCategoryUpdateResponse
} from '@ms-organization-entities';
import {ApiClientConfig} from '../api-client-config';
import {PriorityPatchRequest} from '@primatoo-ms-organization';
import {DataProtectionGovernanceService} from '../interface/data-protection-governance-service';
import {ColumnWithLocalization} from 'it/primatoo/openapi/api/org/schemas/common/ColumnWithLocalization';

@Injectable({
  providedIn: 'root'
})
export class InterestedPersonCategoryService extends DataProtectionGovernanceService {
  private readonly endpoint: string;

  constructor(
    @Inject(ApiClientConfig) private config,
    public httpClient: HttpClient
  ) {
    super(httpClient);
    this.endpoint = this.config.endPoint + '/api/org/interested-categories/';
  }

  setPriority(id: number, request: PriorityPatchRequest): Observable<InterestedCategory> {
    const url = `${this.endpoint}${id}/priority`;
    return this.httpClient.patch<InterestedCategory>(url, request);
  }

  public getInterestedPersonCategories(): Observable<InterestedCategory[]> {
    const url = this.endpoint;
    return this.httpClient.get<InterestedCategory[]>(url);
  }

  public findUserColumns(): Observable<ColumnWithLocalization[]> {
    const url = this.endpoint + `columns`;
    return this.httpClient.get<ColumnWithLocalization[]>(url);
  }

  // public updateUserColumns(columnsConfigurationUpsertRequest: ColumnsConfigurationUpsertRequest): Observable<void> {
  //   const url = this.endpoint + 'user-columns';
  //   return this.httpClient.post<void>(url, columnsConfigurationUpsertRequest);
  // }

  public getInterestedPersonCategoryById(id: number): Observable<InterestedCategory> {
    const url = this.endpoint + id + '/';
    return this.httpClient.get<InterestedCategory>(url);
  }

  public getInterestedPersonCategoryDetails(id: number): Observable<InterestedCategoryDetails> {
    const url = this.endpoint + id + '/details';
    return this.httpClient.get<InterestedCategoryDetails>(url);
  }

  public deleteInterestedPersonCategory(id: number): Observable<InterestedCategory> {
    const url = this.endpoint + id + '/';
    return this.httpClient.delete<InterestedCategory>(url);
  }

  public createInterestedPersonCategory(
    requestBody: InterestedCategoryCreateRequest
  ): Observable<InterestedCategoryCreateResponse> {
    const url = this.endpoint;
    return this.httpClient.post<InterestedCategoryCreateResponse>(url, requestBody);
  }

  public updateInterestedPersonCategory(
    id: number, requestBody: InterestedCategoryUpdateRequest
  ): Observable<InterestedCategoryUpdateResponse> {
    const url = this.endpoint + id + '/';
    return this.httpClient.put<InterestedCategoryUpdateResponse>(url, requestBody);
  }

  getEndPointV1(): string {
    return this.endpoint;
  }
}
